import { Component, Input } from '@angular/core';
import { defaultSize, IconComponent } from '../icon.component';
import { IconSize } from '@nagel-types';

@Component({
    selector: 'cal-styled-icon',
    
    imports: [IconComponent],
    templateUrl: './styled-icon.component.html',
    styleUrl: './styled-icon.component.scss'
})
export class StyledIconComponent {
  @Input() icon: string = '';
  @Input() size: IconSize = defaultSize;
  @Input() className: string = 'custom-icon';
}
